import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useForm, ErrorMessage } from "react-hook-form";
import withSizes from 'react-sizes';

import { Container, Row, Col } from "deltoid/core/Blocks/BootstrapContainers";
import { Card } from "deltoid/core/OneDashCards";
import { H, Caption } from "deltoid/core/Blocks/Typography";
import Form from "deltoid/core/Form";

import SignUpCMS from "../../features/prismic/SignUpCMS";
import { loginWithPassword } from '../../../shared/actions/auth';
import { emailRegex } from '../../../shared/services/validations';
import config from '../../../shared/services/config';
import LoginIllustration from "../../../assets/svgs/loginIllustration.svg";
import PayUIcon from "../../../assets/svgs/PayU-Icon.svg";

const VerifyPassword = (props) => {
  const { register, handleSubmit, errors, getValues, setError, clearError } = useForm();
  const { user } = props.location.state;
  const [passwordShown, setPasswordShown] = useState(false);
  const [isLoginWithOtp, setLoginWithOtp] = useState(false);
  const [showTooltip,setShowTooltip] = useState(false)
  const [isContinue, setIsContinue] = useState(false);
  const [isPartner, setIsPartner] = useState(config.get('product') === 'PARTNER' &&  true);
  const isMFAEnabled = props.location.state.user.isMFAEnabled && props.location.state.user.isPasswordSet

  useEffect(() => {
    if(isLoginWithOtp && user && emailRegex(user.email)) {
      setError('email', 'validation', 'Invalid email')
    }
    else{
      clearError('email');
        if(!isMFAEnabled && isLoginWithOtp){
          props.history.push({
            pathname: '/account/mobile_otp',
            state: {
              ...props.location.state,
              user: user,
            }
          });
        }
    }
  },[isLoginWithOtp])

  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  }

  const forgotPasswordClick = () => {
    props.history.push({
      pathname: '/account/forgot_password',
    });
  }
  const onBack = () => {
    props.history.push({
      pathname: '/account/signup',
      state: {
        ...props.location.state,
      }
    });
  }
  const onSubmit = async (formData) => {
    const { state: historyState } = props.location;
    if(!formData.password) {
      setError('password', 'regex', 'Password can not be empty')
    }
    try {
      formData.email= historyState.user.mobile
      formData.isMFAEnabled = isMFAEnabled
      const loginWithPasswordResponse = await loginWithPassword(props.dispatch, formData);
      if (isMFAEnabled) {
        props.history.push({
          pathname: '/account/mobile_otp',
          state: {
            ...props.location.state,
            user: user,
            password: formData.password,
            isMFAEnabled,
            passwordToken: loginWithPasswordResponse.access_token
          }
        });
      } else {
        props.history.push({
          pathname: '/account/email_otp',
          state: {
            ...props.location.state,

          }
        })
      }
    } catch (e) {
       setError('password', 'regex', e.message)
    }
  };

  return (
    <Container fluid className='vector-bg login-max-width-container'>
      <Row>
        {props.isMobile ?
            <Col md={12} className='p-0 d-flex justify-content-between grey-background login-illustration'>
               <span className='pt-4 px-4'><PayUIcon /></span>
              <LoginIllustration />
            </Col>
              :
            <Col md={6} className='p-0'>
              <SignUpCMS />
            </Col>
          }
        <Col md={5} className={props.isMobile && 'm-0 p-0'}>
        <div className={!props.isMobile && 'login-container mt-5 mx-4'}>
          <Card>
              
              {isContinue ? 
              ( 
              <>
              <H level={5} className="pb-4 co-heading worksansregular-font">
                Welcome Back
              </H>
              <form onSubmit={handleSubmit(onSubmit)} className='px-3 py-3'>
                <Row>
                  <Form.Group className="position-relative mb-3">
                    <Form.Label id="password">
                      Password
                    </Form.Label>
                    <Form.Text
                      id="password"
                      name="password"
                      type={passwordShown ? "text" : "password"}
                      ref={register({
                        required: "Password can not be empty",
                      })}
                      placeholder="Enter your PayU Password"
                      endAdornment={{ type: `${passwordShown ? 'view-disabled' : 'view-1'}`, color: 'default', onClick: () => togglePasswordVisiblity() }}
                    />
                    <ErrorMessage errors={errors} name="password">
                      {({ message }) => (
                        <Form.Message
                          type="error"
                        >
                          {message}
                        </Form.Message>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Row>
                <div className="d-flex flex-column-reverse">
                  <div className="justify-content-end">
                    <Form.Button
                      type="submit"
                      className="w-100 mt-4 font-weight-bold rounded-btn"
                    >
                    Login
                    </Form.Button>
                  </div>
                  <div className="d-flex justify-content-between why-btn">
                    <Form.Button
                      type="button"
                      onClick={() => setLoginWithOtp(true)}
                      variant="underlined"
                      className="p-0 position-relative"
                      endIcon={isMFAEnabled ? { type: 'lock', color: 'dark'} : {}}
                      onMouseEnter={() => setShowTooltip(isMFAEnabled)}
                      onMouseLeave={() => setShowTooltip(false)}
                    >
                      Login using OTP
                      {
                        isMFAEnabled ? (
                          <div className={`tooltip-container ${showTooltip ? '' : 'hide'}`}>
                            Two Step Verification is enabled
                          </div>
                        ) : null
                      }
                    </Form.Button>
                    <Form.Button onClick={forgotPasswordClick} variant="underlined" className="p-0"  type="button" >
                      Forgot Password
                    </Form.Button>
                  </div>
                </div>
                <Row className="d-flex justify-content-center pt-4">
                  <Caption variant="light" className={props.isMobile ? 'pt-1 align-button-text pr-2' : 'align-button-text pr-3'}>
                    Don’t have an account with PayU?
                  </Caption>
                  <Form.Button
                    onClick={() =>
                      props.history.push({
                        pathname: "/account/signup",
                      })
                    }
                    variant="underlined"
                  >
                    Sign Up
                  </Form.Button>
                </Row>
              </form>
              </>
              )
              :
              (
                <>
                <H level={5} variant="regular" className="pb-4 co-heading worksansregular-font">
                    Mobile Number already exists with PayU
                </H>
                <Caption>
                  Please continue with your old password to add new {isPartner ? 'partner' : 'merchant'} account
                </Caption>
                <div className="d-flex flex-column-reverse pt-3">
                  <div className="d-flex justify-content-around">
                    <Form.Button 
                      variant="underlined"
                      className="p-0"
                      type="button"
                      onClick={onBack}
                    >
                      Back
                    </Form.Button>
                    <Form.Button
                      type="button"
                      onClick={() => setIsContinue(true)}
                      variant="underlined"
                      className="p-0"
                    >
                      Continue
                    </Form.Button>
                  </div>
                </div>
              </>
              )}
          </Card>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 768,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

const mapStateToProps = (state) => {
  return {
    user: state.session.User.data.data
  };
};

const Responsive = withSizes(mapSizesToProps)(VerifyPassword);
export default connect(mapStateToProps, mapDispatchToProps)(Responsive);